import React from 'react';
import { Box, Flex, Text, IconButton, HStack, useColorModeValue } from '@chakra-ui/react';
import { FiPlay, FiPause, FiX } from 'react-icons/fi';
import { useAudioContext } from '../../context/AudioContext';

export default function GlobalAudioBar() {
  const { 
    isPlaying, 
    isPaused, 
    currentTitle, 
    togglePlayPause, 
    stopAudio 
  } = useAudioContext();

  const bg = useColorModeValue('white', 'gray.800');
  const borderTopColor = useColorModeValue('gray.200', 'gray.700');

  // Si no hay nada reproduciéndose, ni pausado, no mostramos la barra
  if (!isPlaying && !isPaused && !currentTitle) return null;

  return (
    <Box
      position="fixed"
      bottom={{ base: '64px', md: '0' }} // Por encima del BottomNav en móvil, abajo del todo en desktop
      left={{ base: '0', md: '72px', xl: '260px' }} // Respetar el SideNav en desktop
      right="0"
      bg={bg}
      borderTop="1px solid"
      borderTopColor={borderTopColor}
      boxShadow="0 -4px 6px -1px rgba(0, 0, 0, 0.1)"
      p={3}
      zIndex={999}
      transition="all 0.3s"
    >
      <Flex alignItems="center" justifyContent="space-between" maxW="container.xl" mx="auto">
        <Box flex="1" overflow="hidden" pr={4}>
          <Text fontSize="sm" fontWeight="bold" color="brand.500" textTransform="uppercase" letterSpacing="wider">
            Reproduciendo
          </Text>
          <Text fontSize="md" fontWeight="semibold" noOfLines={1}>
            {currentTitle || "Audio"}
          </Text>
        </Box>

        <HStack spacing={2}>
          <IconButton
            icon={isPaused ? <FiPlay /> : <FiPause />}
            onClick={togglePlayPause}
            colorScheme="brand"
            variant="solid"
            rounded="full"
            aria-label={isPaused ? "Reanudar" : "Pausar"}
          />
          <IconButton
            icon={<FiX />}
            onClick={stopAudio}
            colorScheme="gray"
            variant="ghost"
            rounded="full"
            aria-label="Cerrar reproductor"
          />
        </HStack>
      </Flex>
    </Box>
  );
}
